export default __webpack_public_path__ + "static/media/mountain.46bc12e2.mp3";